<div class="px-3 md:px-10 xl:px-[175px] w-full max-w-[1920px] mx-auto">

<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": "https://innovationplaza.it/#website",
      "url": "https://innovationplaza.it",
      "name": "Innovation Plaza — Consulenza per l'Innovazione",
      "description": "Supportiamo imprese, istituzioni e imprenditori nei processi di innovazione, strategia, accesso ai fondi europei e sviluppo imprenditoriale.",
      "inLanguage": "it-IT",
      "publisher": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://innovationplaza.it/?s={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "@id": "https://innovationplaza.it/#organization",
      "name": "Innovation Plaza",
      "url": "https://innovationplaza.it",
      "email": "info@innovationplaza.it",
      "telephone": "+39-02-49539510",
      "image": "https://innovationplaza.it/assets/og-image.jpg"
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://innovationplaza.it/#localbusiness-milano",
      "name": "Innovation Plaza — Sede legale e Nord Italia (Milano)",
      "parentOrganization": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "image": "https://innovationplaza.it/assets/og-image.jpg",
      "telephone": "+39-02-49539510",
      "email": "info@innovationplaza.it",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Viale Papiniano 44",
        "addressLocality": "Milano",
        "addressRegion": "MI",
        "postalCode": "20123",
        "addressCountry": "IT"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 45.4625,
        "longitude": 9.1710
      },
      "openingHoursSpecification": [{
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }],
      "priceRange": "$$",
      "currenciesAccepted": "EUR",
      "paymentAccepted": "Bonifico bancario, Fattura elettronica",
      "hasMap": "https://maps.google.com/?q=Viale+Papiniano+44+Milano+20123"
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://innovationplaza.it/#localbusiness-brindisi",
      "name": "Innovation Plaza — Sede Centro-Sud Italia (Brindisi)",
      "parentOrganization": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "image": "https://innovationplaza.it/assets/og-image.jpg",
      "url": "https://innovationplaza.it",
      "email": "info@innovationplaza.it",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Palazzo Guerrieri, Via Guerrieri 7",
        "addressLocality": "Brindisi",
        "addressRegion": "BR",
        "postalCode": "72100",
        "addressCountry": "IT"
      },
      "openingHoursSpecification": [{
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }]
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://innovationplaza.it/#localbusiness-cinisello",
      "name": "Innovation Plaza — Sede operativa Nord (Cinisello Balsamo)",
      "parentOrganization": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "image": "https://innovationplaza.it/assets/og-image.jpg",
      "email": "info@innovationplaza.it",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Viale Fulvio Testi 11",
        "addressLocality": "Cinisello Balsamo",
        "addressRegion": "MI",
        "postalCode": "20092",
        "addressCountry": "IT"
      },
      "openingHoursSpecification": [{
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }]
    }
  ]
}
</script>

    <div class="absolute z-[-1] top-0 left-0 w-screen h-[614px]"
        style="background:radial-gradient(circle, #719CFF 0%, #283759 100%);"></div>

    <div class="mt-[60px] relative text-222222 text-font40px aspect43:text-center font-normal uppercase">
        <h1 class="text-font36px leading-[40px] font-extrabold mb-2.5 text-center">
            UN SOLO SPAZIO, TANTE SOLUZIONI
        </h1>
    </div>

    <div class="items-center text-white font-normal text-font19px aspect43:text-font26px max-w-[100%] mx-auto flex">
        <div class="text-center text-justify-disabled mx-auto text-font24px font-normal leading-[25px]">
            La piattaforma Al-powered che ti guida tra bandi,<br>
            partner e risorse per innovare 
        </div>
    </div>

    <div (click)="goTo('cerca-bando')"
        class="mt-8 mb-[88px] text-white cursor-pointer bg-quintary mx-auto w-[226px] h-[47px] flex items-center place-content-center text-font24px font-bold rounded-full">
        Ricerca bandi
    </div>
    
    <div class="w-full bg-white rounded-[20px] shadow-lg p-5 xl:p-10">
        <div class="flex items-center justify-between mb-6">
            <div class="text-font32px font-semibold text-[#222222]">Cerca, seleziona, agisci</div>

        <!-- <div (click)="goTo('cerca-bando')" class="text-white cursor-pointer bg-quintary 
               w-[226px] h-[47px] flex items-center justify-center 
               text-font24px font-bold rounded-full"> Ricerca bandi </div> -->
    </div>

        <div class="text-font24px text-[#364349] mb-12">Accedi a bandi sempre aggiornati e scopri le opportunità più
            rilevanti per i tuoi obiettivi di innovazione, crescita o trasformazione</div>
        <div class="flex flex-wrap gap-[52px] place-content-between">
            <div class="w-[295px]">
                <div class="text-[#222222] text-font24px font-bold">Partner</div>
                <div class="text-[#364349] text-font20px font-normal text-justify">Trova relazioni strategiche e crea
                    collaborazioni
                    mirate per rafforzare i tuoi progetti</div>
            </div>
            <div class="w-[295px]">
                <div class="text-[#222222] text-font24px font-bold">Imprese e startup</div>
                <div class="text-[#364349] text-font20px font-normal text-justify">Accedi ai bandi giusti e gestisci
                    tutto in un unico
                    spazio. l’AI ottimizza opportunità e scadenze</div>
            </div>
            <div class="w-[295px]">
                <div class="text-[#222222] text-font24px font-bold">Enti Pubblici</div>
                <div class="text-[#364349] text-font20px font-normal text-justify">Semplifica l’accesso ai fondi. Trova
                    risorse,
                    monitora progetti e genera report con facilità</div>
            </div>
        </div>
    </div>

    <div class="flex items-center gap-5 mt-6 mb-8">
        <img src="../../../assets/HOME1.png" alt="Image" class="rounded-[20px] object-contain" width="100%">
    </div>

    <div class="mt-[52px] rounded-[20px] px-2.5 bg-[#F1F5FF] py-[52px] shadow-lg">
        <div class="text-font32px text-center font-bold text-[#222222] ">Dalla ricerca del bando giusto alla gestione
            operativa del progetto</div>
        <div class="text-center text-font28px text-[#222222]">Ogni funzione della
            piattaforma è pensata per semplificare il tuo percorso,<br> aumentare le probabilità di successo e
            valorizzare il tuo tempo</div>
    </div>
    <div class="xl:flex mt-[52px] gap-5 min-h-[409px]">
        <div class="shadow-lg rounded-[20px] xl:w-[calc(60%-10px)] p-5 xl:p-10 xl:pr-[51px] relative min-h-[409px]">
            <div class="text-font28px font-bold text-[#222222]">Come funziona</div>
            <div class="mt-5 text-[#364349] text-font24px pb-20 text-justify">II nostro processo è semplice, guidato e
                pensato per farti risparmiare tempo
                <br><br>
                Segui pochi passaggi per accedere ai bandi giusti, ricevere supporto e portare avanti il tuo progetto
            </div>
            <div (click)="goTo('cerca-bando')"
                class="text-white cursor-pointer bottom-10 absolute bg-quintary w-[226px] h-[47px] flex items-center place-content-center text-font24px font-bold rounded-full">
                Ricerca bandi
            </div>
        </div>
        <div
            class="shadow-lg rounded-[20px] mt-10 xl:mt-0 xl:w-[calc(40%-10px)] pt-[24px] px-5 md:px-[36px] relative overflow-hidden min-h-[409px]">
            <div class="text-font32px font-bold leading-[31px] text-[#222222]">Dalla ricerca alla candidatura, dalla
                gestione alla reportistica</div>
            <svg class="absolute left-[-36px] bottom-4 h-[249px] w-fit md:w-[440px]" width="405" height="249"
                viewBox="0 0 405 249" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M404.048 138.534C404.048 150.536 394.319 160.265 382.318 160.265C370.316 160.265 360.587 150.536 360.587 138.534V72.4277C313.317 121.088 250.43 185.712 234.705 201.438C206.869 229.273 175.007 223.534 159.997 213.822L159.137 213.266L158.336 212.634C149.189 205.412 125.895 185.838 103.465 163.408C100.227 160.17 97.6117 158.868 95.8394 158.302C94.0484 157.73 92.2783 157.642 90.4067 157.946C86.1313 158.643 81.9408 161.34 79.8726 163.408L1.09814 242.183C-7.38821 250.669 -21.1489 250.669 -29.6353 242.183C-38.1216 233.696 -38.1216 219.935 -29.6353 211.448L49.1392 132.674C56.1254 125.688 68.2333 117.52 83.4243 115.047C99.9631 112.355 118.327 116.801 134.2 132.674C154.212 152.687 175.09 170.359 184.006 177.505C184.291 177.623 184.716 177.785 185.283 177.935C186.471 178.249 187.982 178.452 189.702 178.34C192.73 178.142 197.785 176.888 203.97 170.703C219.323 155.35 281.018 91.9595 328.133 43.4619H249.217C237.216 43.4619 227.486 33.7329 227.486 21.7314C227.486 9.72986 237.216 0 249.217 0H404.048V138.534Z"
                    fill="#F15928" />
            </svg>

        </div>
    </div>
    <div class="mt-[76px] lg:flex gap-5 w-full">
        <div
            class="lg:w-[calc(42%-10px)] h-[191px] items-center gap-5 p-4 sm:p-12 rounded-[20px] shadow-lg flex bg-[#F1F5FF]">
            <div class="font-bold text-[128px] text-[#719CFF]">1</div>
            <div class="text-font32px leading-[36px] md:text-font40px text-[#222222] md:leading-[45px] font-bold">
                Registrati e crea il tuo profilo</div>
        </div>
        <div
            class="mt-5 lg:mt-0 lg:w-[calc(58%-10px)] h-[191px] items-center gap-5 p-4 sm:p-12 rounded-[20px] shadow-lg flex bg-[#FFFFFF]">
            <div class="font-bold text-[128px] text-[#719CFF]">2</div>
            <div class="text-font32px leading-[36px] md:text-font40px text-[#222222] md:leading-[45px] font-bold">
                Visualizza i bandi sulla piattaforma</div>
        </div>
    </div>
    <div class="mt-5 lg:mt-[76px]  lg:flex gap-5 w-full">
        <div
            class="lg:w-[calc(58%-10px)] h-[191px] items-center gap-5 p-4 sm:p-12 rounded-[20px] shadow-lg flex bg-[#FFFFFF]">
            <div class="font-bold text-[128px] text-[#719CFF]">3</div>
            <div class="text-font32px leading-[36px] md:text-font40px text-[#222222] md:leading-[45px] font-bold">Ricevi
                notifiche sui nuovi bandi</div>
        </div>
        <div
            class="mt-5 lg:mt-0 lg:w-[calc(42%-10px)] h-[191px] items-center gap-5 p-4 sm:p-12 rounded-[20px] shadow-lg flex bg-[#F1F5FF]">
            <div class="font-bold text-[128px] text-[#719CFF]">4</div>
            <div class="text-font32px leading-[36px] md:text-font40px text-[#222222] md:leading-[45px] font-bold">Scegli
                un piano di abbonamento</div>
        </div>
    </div>

    <!-- <div class="flex items-center gap-5 mt-6 mb-8">
        <img src="../../../assets/img3.jpg" alt="work" class=" object-contain" width="100%">
    </div> -->

    <div class="mt-[112px] md:flex gap-5 w-full">
        <div class="md:w-[calc(50%-10px)]">
            <div class="text-font32px font-bold text-[#222222]">Siamo esperti nel settore</div>
            <div class="text-[#364349] text-font24px text-justify">Conosciamo a fondo le sfide dell’innovazione: bandi
                complessi,
                burocrazia, gestione dei progetti e necessità di creare connessioni strategiche <br> <br>
                Per questo abbiamo sviluppato un sistema intelligente che semplifica l’accesso alle opportunità,
                supporta imprese, startup ed enti pubblici e aumenta le probabilità di successo. Un’esperienza costruita
                sul campo, per rendere l’innovazione davvero accessibile e orientata al futuro</div>
        </div>
        <div class="md:w-[calc(50%-10px)] flex flex-wrap gap-x-5 gap-y-3">
            <div
                class="w-[calc(50%-10px)] rounded-[20px] h-[202px] shadow-lg flex items-center place-content-center px-2">
                <div><svg class="mx-auto" width="100" height="100" viewBox="0 0 100 100" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M38.3334 48.75H59.1667" stroke="#719CFF" stroke-width="7" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M48.75 59.1663V38.333" stroke="#719CFF" stroke-width="7" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M47.9167 87.4997C69.778 87.4997 87.5 69.7776 87.5 47.9163C87.5 26.0551 69.778 8.33301 47.9167 8.33301C26.0554 8.33301 8.33337 26.0551 8.33337 47.9163C8.33337 69.7776 26.0554 87.4997 47.9167 87.4997Z"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M91.6667 91.6663L83.3334 83.333" stroke="#719CFF" stroke-width="7"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <div class="text-center font-bold text-font20px leading-[31px]">Analisi dei bandi</div>
                </div>
            </div>
            <div
                class="w-[calc(50%-10px)] rounded-[20px] h-[202px] shadow-lg flex items-center place-content-center px-2">
                <div><svg class="mx-auto" width="100" height="100" viewBox="0 0 100 100" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M68.75 39.583L51.25 57.083L44.5833 47.083L31.25 60.4163" stroke="#719CFF"
                            stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M60.4166 39.583H68.75V47.9163" stroke="#719CFF" stroke-width="7" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M37.5 91.6663H62.5C83.3334 91.6663 91.6667 83.333 91.6667 62.4997V37.4997C91.6667 16.6663 83.3334 8.33301 62.5 8.33301H37.5C16.6667 8.33301 8.33337 16.6663 8.33337 37.4997V62.4997C8.33337 83.333 16.6667 91.6663 37.5 91.6663Z"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <div class="text-center font-bold text-font20px leading-[31px]">Reportistica avanzata</div>
                </div>
            </div>
            <div
                class="w-[calc(50%-10px)] rounded-[20px] h-[202px] shadow-lg flex items-center place-content-center px-2">
                <div><svg class="mx-auto" width="100" height="100" viewBox="0 0 100 100" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M79.1666 66.6667V27.0833C79.1666 22.5 75.4166 18.75 70.8333 18.75H47.9166"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M58.3334 8.33301L45.8334 18.7497L58.3334 29.1663" stroke="#719CFF" stroke-width="7"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M79.1666 91.667C86.0702 91.667 91.6666 86.0706 91.6666 79.167C91.6666 72.2634 86.0702 66.667 79.1666 66.667C72.2631 66.667 66.6666 72.2634 66.6666 79.167C66.6666 86.0706 72.2631 91.667 79.1666 91.667Z"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M20.8334 33.333V72.9163C20.8334 77.4997 24.5834 81.2497 29.1667 81.2497H52.0834"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M41.6666 91.6663L54.1666 81.2497L41.6666 70.833" stroke="#719CFF" stroke-width="7"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M20.8334 33.333C27.7369 33.333 33.3334 27.7366 33.3334 20.833C33.3334 13.9294 27.7369 8.33301 20.8334 8.33301C13.9298 8.33301 8.33337 13.9294 8.33337 20.833C8.33337 27.7366 13.9298 33.333 20.8334 33.333Z"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <div class="text-center font-bold text-font20px leading-[31px]">Reti strategiche</div>
                </div>
            </div>
            <div
                class="w-[calc(50%-10px)] rounded-[20px] h-[202px] shadow-lg flex items-center place-content-center px-2">
                <div><svg class="mx-auto" width="100" height="100" viewBox="0 0 100 100" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M79.1667 37.4997C79.1667 43.5413 77.375 49.0831 74.2917 53.7081C69.7917 60.3747 62.6667 65.083 54.375 66.2914C52.9584 66.5414 51.5 66.6663 50 66.6663C48.5 66.6663 47.0417 66.5414 45.625 66.2914C37.3334 65.083 30.2084 60.3747 25.7084 53.7081C22.625 49.0831 20.8334 43.5413 20.8334 37.4997C20.8334 21.3747 33.875 8.33301 50 8.33301C66.125 8.33301 79.1667 21.3747 79.1667 37.4997Z"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M88.5417 76.9584L81.6667 78.5833C80.125 78.9583 78.9167 80.125 78.5833 81.6667L77.125 87.7917C76.3333 91.1251 72.0833 92.1251 69.875 89.5001L50 66.6667L30.125 89.5417C27.9167 92.1666 23.6667 91.1666 22.875 87.8333L21.4167 81.7083C21.0417 80.1666 19.8333 78.9583 18.3333 78.625L11.4583 77.0001C8.29167 76.2501 7.16667 72.2916 9.45834 70L25.7083 53.75C30.2083 60.4167 37.3333 65.1251 45.625 66.3334C47.0417 66.5834 48.5 66.7084 50 66.7084C51.5 66.7084 52.9583 66.5834 54.375 66.3334C62.6667 65.1251 69.7917 60.4167 74.2917 53.75L90.5417 70C92.8333 72.25 91.7083 76.2084 88.5417 76.9584Z"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M52.4167 24.917L54.875 29.8336C55.2084 30.5003 56.0834 31.167 56.875 31.292L61.3334 32.042C64.1667 32.5003 64.8334 34.5836 62.7917 36.6253L59.3334 40.0836C58.75 40.6669 58.4167 41.792 58.625 42.6253L59.6251 46.917C60.4167 50.292 58.6251 51.6252 55.6251 49.8336L51.4584 47.3753C50.7084 46.9169 49.4584 46.9169 48.7084 47.3753L44.5417 49.8336C41.5417 51.5836 39.75 50.292 40.5417 46.917L41.5417 42.6253C41.7084 41.8337 41.4167 40.6669 40.8334 40.0836L37.3751 36.6253C35.3334 34.5836 36 32.542 38.8334 32.042L43.2917 31.292C44.0417 31.167 44.9167 30.5003 45.25 29.8336L47.7084 24.917C48.9167 22.2503 51.0834 22.2503 52.4167 24.917Z"
                            stroke="#719CFF" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <div class="text-center font-bold text-font20px leading-[31px]">Supporto guidato</div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex items-center gap-5 mt-6 mb-8">
        <img src="../../../assets/HOME2.jpg" alt="Image" class="rounded-[20px] object-contain" width="100%">
    </div>

    <div class="mt-[142px] gap-5 md:flex">
        <div class="w-[360px] hidden md:block">
            <svg width="360" height="267" viewBox="0 0 360 267" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M151 138.103H95.3702C95.3702 74.76 132.457 56.469 151 55.2414V0C72.3765 5.89241 37.8859 78.5655 30.4686 114.166V267H151V138.103Z"
                    fill="#D3E0FF" />
                <path
                    d="M329.531 138.103H273.902C273.902 74.76 310.988 56.469 329.531 55.2414V0C250.908 5.89241 216.417 78.5655 209 114.166V267H329.531V138.103Z"
                    fill="#D3E0FF" />
            </svg>
        </div>


        <div class="md:w-[calc(100%-380px)]">
            <div class="text-[#222222] text-font28px text-justify">Non serviva un altro motore di ricerca, ma una
                soluzione che
                semplificasse davvero l’innovazione. Da qui nasce <span class="font-bold">Innovation Smart Plaza</span>
                un sistema che rende accessibili opportunità e strumenti, supportando imprese, startup ed enti verso
                un’innovazione più inclusiva e orientata al futuro</div>
            <div class="mt-8">
                <div class="text-font24px italic font-bold">Francesco Carolla</div>
                <div class="text-font18px font-bold italic text-[#78909C]">Amministratore Unico Innovation Plaza srl
                </div>
            </div>
        </div>
    </div>
</div>